/**
 * Mock account lifecycle service.
 *
 * Used by the prototype and the e2e/preview build (no Firebase backend). It stands
 * in for the callables without server state: deletion and cancellation resolve,
 * acceptance resolves, and export returns a small representative object so the
 * download path can be exercised without a backend.
 *
 * @returns {import("../interfaces.js").AccountService}
 */
export function createMockAccountService() {
  const DAY = 24 * 60 * 60 * 1000;
  return {
    async requestDeletion() {
      return { status: "pendingDeletion", deletesAt: Date.now() + 30 * DAY };
    },
    async cancelDeletion() {},
    async exportData() {
      return {
        exportedAt: Date.now(),
        account: { email: "demo@example.com", planId: "free", subscriptionStatus: "none" },
        profiles: [],
      };
    },
    async acceptPolicies() {},
  };
}
